import { api } from '@/lib/apiClient'
import type { AuthResponse, LoginRequest, RegisterRequest, User } from '@/types/api'

export interface AccountSecurity {
  id: number
  email: string
  fullName: string
  emailVerified: boolean
}

export const authApi = {
  register: (request: RegisterRequest) => api.post<AuthResponse>('/auth/register', request),
  login: (request: LoginRequest) => api.post<AuthResponse>('/auth/login', request),
  refresh: () => api.post<AuthResponse>('/auth/refresh'),
  logout: () => api.post<void>('/auth/logout'),
  me: () => api.get<User>('/me'),
  security: () => api.get<AccountSecurity>('/account/security'),
  requestEmailVerification: () => api.post<{ message: string }>('/account/verification'),
  changeUnverifiedEmail: (email: string, password: string) => api.put<{ message: string }>('/account/email', { email, password }),
  verifyEmail: (token: string) => api.post<{ message: string }>('/auth/verify-email', { token }),
  requestPasswordReset: (email: string) => api.post<{ message: string }>('/auth/request-password-reset', { email }),
  resetPassword: (token: string, password: string) => api.post<{ message: string }>('/auth/reset-password', { token, password }),
}
